import TickerName from './TickerName';
export default TickerName;
